import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const InputCheckbox = React.forwardRef(
  (
    {
      checked,
      disabled,
      indeterminate,
      label,
      onChange,
      onClick,
      subtitle,
      value,
      variant,
      ...props
    },
    ref
  ) => {
    const inputRef = useRef(null);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate;
      }
    }, [indeterminate]);

    return (
      <div
        className={`input-checkbox input-checkbox--${variant}`}
        ref={ref}
        onClick={onClick}
      >
        <label className="input-checkbox__label-wrapper">
          <input
            ref={inputRef}
            type="checkbox"
            className="input-checkbox__input"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            value={value}
            {...props}
          />
          <span className="input-checkbox__box" aria-hidden="true" />
          <div className="input-checkbox__texts">
            <span className="input-checkbox__label">{label}</span>
            {subtitle && <span className="input-checkbox__subtitle">{subtitle}</span>}
          </div>
        </label>
      </div>
    );
  }
);

InputCheckbox.displayName = 'InputCheckbox';

InputCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.string,
  variant: PropTypes.oneOf(['check', 'square']),
};

InputCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false,
  label: '',
  onChange: () => {},
  subtitle: '',
  variant: 'check',
};

export default InputCheckbox;
